module.exports = __webpack_public_path__ + "img/5.3191b8ad.jpg";